import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Router from 'next/router';
import { useRouter } from "next/router";
import clsx from 'clsx';

import { CircularProgress } from "@material-ui/core";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import { Topbar, Sidebar } from './components';
// import Sidebar from "../sidebar";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 256,
    // backgroundColor: '#f4f6f8'
    backgroundColor: '#F7F9FC'
  },
  content: {
    height: '100%'
  }
}));

const SidebarPage = ({ children }) => {
  const router = useRouter();
  const [isLoading, setLoading] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    // <div>hello</div>
      <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Topbar onSidebarOpen={handleSidebarOpen}/>
      <Sidebar 
      onClose={handleSidebarClose}
      open={shouldOpenSidebar}
      variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main className={classes.content}>
        {children}
      </main>
    </div>
  );
};

export default SidebarPage;